import styled from "styled-components";
import colors from "../../../config/colors";
import { headerSize, panelSpacing } from "../../../common/styles";

export const ProgramBrowserContainer = styled.div`
    background-color:${colors.secondary};
    padding:${panelSpacing}px;
    height:calc(1000vh - ${headerSize}px);
    box-sizing: border-box;
`;